<aside class="sidebar">
  <ng-content select="[sidebar]"></ng-content>
</aside>

<main class="sidebar-content">
  <ng-content select="[content]"></ng-content>
</main>
